import { createAction, props } from '@ngrx/store';

export const openPage = createAction('[Newsfeed/Page] Page opened');
export const loadMore = createAction('[Newsfeed/Page] Load more content');
export const inputSearchTerm = createAction(
  '[Newsfeed/Page] Input search term on Newsfeed',
  props<{ searchTermFragment: string }>()
);
export const performSearch = createAction('[Newsfeed/Page] Perform search from Newsfeed');
export const selectRootChannel = createAction('[Newsfeed/Page] Select Root Newsfeed Channel');
export const selectSubscribedChannel = createAction(
  '[Newsfeed/Page] Select Subscribed Newsfeed Channel',
  props<{ id: string; fairId: string }>()
);
export const selectLastViewedChannel = createAction('[Newsfeed/Page] Select "Last Viewed" Channel');
